import { Redirect } from 'containers/Redirect';
import { useGetMarketsPagePath } from 'hooks/useGetMarketsPagePath';

export const MarketsRootRedirect: React.FC = () => {
  const { marketsPagePath } = useGetMarketsPagePath();

  return <Redirect to={marketsPagePath} />;
};
